import { TYPES } from '../../common/constants';

export const setServiceRequestFormData = payload => ({
  type: TYPES.SET_SERVICE_REQUEST_FORM_DATA,
  payload,
});

export const setServiceRequestFormNextStep = () => ({
  type: TYPES.SET_SERVICE_REQUEST_FORM_NEXT_STEP,
});

export const setServiceRequestFormPreviousStep = () => ({
  type: TYPES.SET_SERVICE_REQUEST_FORM_PREVIOUS_STEP,
});

export const setServiceRequestFormStep = step => ({
  type: TYPES.SET_SERVICE_REQUEST_FORM_STEP,
  payload: {
    step,
  },
});
export const clearServiceRequestFormData = (payload) => ({
  type: TYPES.CLEAR_SERVICE_REQUESTS_FORM_DATA,
  payload
});

export const exitServiceRequestForm = () => ({
  type: TYPES.EXIT_SERVICE_REQUEST_FORM,
});

export const saveServiceRequest = () => ({
  type: TYPES.SAVE_SERVICE_REQUEST,
});

export const setServiceRequestFormIsVisible = payload => ({
  type: TYPES.SET_SERVICE_REQUEST_FORM_IS_VISIBLE,
  payload
});
